module.exports = __webpack_public_path__ + "img/landing_page_5.24b81160.png";